"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.debounce"));

var _uiKit = require("@devsta/ui-kit");

var _SelectUserItem = _interopRequireDefault(require("../../SelectUserItem"));

require("../styles/_assign-owner.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OWNER_ROLE_NAME = 'OWNER';

var AssignOwnerModal = /*#__PURE__*/function (_Component) {
  _inherits(AssignOwnerModal, _Component);

  var _super = _createSuper(AssignOwnerModal);

  function AssignOwnerModal(_ref) {
    var _this;

    var _ownerCollaborator = _ref.ownerCollaborator;

    _classCallCheck(this, AssignOwnerModal);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleButtonClick", (0, _lodash.default)(function (user) {
      return function () {
        var _this$state$selectedO = _this.state.selectedOwner;
        _this$state$selectedO = _this$state$selectedO === void 0 ? {} : _this$state$selectedO;
        var userId = _this$state$selectedO.userId;

        _this.setState({
          selectedOwner: userId !== user.userId ? user : void 0
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "fetchRoles", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getRoles, _yield$getRoles, data, error, ownerRole;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getRoles = _this.props.getRoles;
              _context.next = 3;
              return getRoles();

            case 3:
              _yield$getRoles = _context.sent;
              data = _yield$getRoles.data;
              error = _yield$getRoles.error;

              if (!(!data || !data.getRoles || error)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              ownerRole = data.getRoles.find(function (_ref3) {
                var name = _ref3.name;
                return name === OWNER_ROLE_NAME;
              });

              _this.setState({
                ownerRoleId: ownerRole && ownerRole.roleId
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "searchUsers", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var searchTerm,
          getUsersByName,
          _yield$getUsersByName,
          data,
          error,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              searchTerm = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              getUsersByName = _this.props.getUsersByName;
              _context2.next = 4;
              return getUsersByName(searchTerm);

            case 4:
              _yield$getUsersByName = _context2.sent;
              data = _yield$getUsersByName.data;
              error = _yield$getUsersByName.error;

              if (!(!data || !data.getUsersByName || error)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return");

            case 9:
              _this.setState({
                users: data.getUsersByName
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (_ref5) {
      var value = _ref5.target.value;

      _this.searchUsers(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props, ownerCollaborator, onOwnerChanged, upsertRoleAssignments, onClose, organisationId, _this$state, selectedOwner, ownerRoleId, _yield$upsertRoleAssi, data, error;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props = _this.props, ownerCollaborator = _this$props.ownerCollaborator, onOwnerChanged = _this$props.onOwnerChanged, upsertRoleAssignments = _this$props.upsertRoleAssignments, onClose = _this$props.onClose, organisationId = _this$props.organisationId;
              _this$state = _this.state, selectedOwner = _this$state.selectedOwner, ownerRoleId = _this$state.ownerRoleId;

              if (!(!selectedOwner || !selectedOwner.userId)) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              _context3.next = 6;
              return upsertRoleAssignments([_objectSpread({}, ownerCollaborator ? {
                resourceRoleAssignmentId: ownerCollaborator.resourceRoleAssignmentId
              } : {}, {
                userId: selectedOwner.userId,
                organisationId: organisationId,
                roleName: OWNER_ROLE_NAME,
                roleId: ownerRoleId
              })]);

            case 6:
              _yield$upsertRoleAssi = _context3.sent;
              data = _yield$upsertRoleAssi.data;
              error = _yield$upsertRoleAssi.error;

              if (!error) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return");

            case 11:
              onOwnerChanged(data.upsertRoleAssignments);
              onClose();

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _this.state = {
      ownerRoleId: void 0,
      selectedOwner: _ownerCollaborator && _ownerCollaborator.user,
      users: []
    };
    return _this;
  }

  _createClass(AssignOwnerModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchRoles();
      this.searchUsers();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          visible = _this$props2.visible,
          onClose = _this$props2.onClose,
          ownerCollaborator = _this$props2.ownerCollaborator;
      var _this$state2 = this.state,
          selectedOwner = _this$state2.selectedOwner,
          users = _this$state2.users;
      var currentOwner = ownerCollaborator && ownerCollaborator.user;
      return /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
        key: "assign-owner-modal",
        title: "Assign Video Owner",
        visible: visible,
        onClose: onClose,
        onSave: this.onSave,
        saveDisabled: !selectedOwner || !selectedOwner.userId,
        stayOpenOnSave: true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "assign-owner"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, "Current Owner"), currentOwner ? /*#__PURE__*/_react.default.createElement("div", {
        className: "assign-owner__selected"
      }, /*#__PURE__*/_react.default.createElement(_SelectUserItem.default, {
        user: currentOwner,
        selected: true
      })) : /*#__PURE__*/_react.default.createElement("div", {
        className: "assign-owner__empty"
      }, "Select video owner"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, "Select New Owner"), /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
        placeholder: "Search",
        prefix: "search",
        onChange: (0, _lodash2.default)(this.onInputChange, 300),
        clearButton: /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "close",
          size: 10,
          color: "nevada"
        })
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "assign-owner__list"
      }, users.map(function (user) {
        return /*#__PURE__*/_react.default.createElement(_SelectUserItem.default, {
          key: user.userId,
          user: user,
          selected: selectedOwner && selectedOwner.userId === user.userId,
          onButtonClick: _this2.handleButtonClick(user)
        });
      })));
    }
  }]);

  return AssignOwnerModal;
}(_react.Component);

exports.default = AssignOwnerModal;